<template>
  <section class="status-section">
    <div class="ds-container ds-padding-top-48">
      <div class="ds-grid ds-justify-content-center">
        <div class="ds-grid__col ds-grid__col--12 ds-lg-grid__col--10">
          <div class="ds-margin-bottom-24">
            <h2
              :id="`status-section-title-${uid}`"
              class="ds-heading-small"
            >
              {{ title }}
            </h2>
          </div>
          <div :aria-describedby="`status-section-title-${uid}`">
            <div v-if="!items.length">
              <div class="ds-padding-y-12 ds-md-padding-y-24 ds-background-color-grey-100">
                <p
                  class="ds-text-align-center ds-color-grey-450"
                  data-j-error-message
                >
                  {{ errorMessage }}
                </p>
              </div>
              
              <div
                v-if="link"
                class="ds-margin-top-24"
              >
                <DsLink
                  v-bind="link"
                  :icon-right="{ category: 'arrows', name: 'chevron-right-small' }"
                  :tracking-data="{ 'component-name': $options.name, text: link.content, title }"
                  data-j-link
                />
              </div>
            </div>
            <ul
              v-else
              data-j-item-list
            >
              <StatusGroupTransition>
                <li
                  v-for="(item, index) in items"
                  :key="`status-maintenance-card-${index}`"
                  class="ds-width-full"
                >
                  <StatusCard
                    :class="{ 'ds-margin-top-12': index !== 0 }"
                    :section-title="title"
                    :title="item.title"
                    :date="item.date"
                    :icon="item.icon"
                    :tag-label="item.tagLabel"
                    :opened="isOpen && index === 0"
                    :color="cardColor"
                  >
                    <component
                      :is="sectionType"
                      :content="this.isIncident ? item.items : item.description"
                    />
                  </StatusCard>
                </li>
                <li
                  v-if="link"
                  class="ds-margin-top-24"
                >
                  <DsLink
                    v-bind="link"
                    :icon-right="{ category: 'arrows', name: 'chevron-right-small' }"
                    :tracking-data="{ 'component-name': $options.name, text: link.content, title }"
                    data-j-link
                    nuxt
                  />
                </li>
              </StatusGroupTransition>
            </ul>
            <slot name="statusSectionButton" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import DsLink from 'website-design-system/src/molecules/link/link'
import uid from 'website-design-system/src/utils/mixins/uid/uid'
import StatusCard from '@/components/status-card/status-card'
import StatusGroupTransition from '@/components/status-group-transition'
import StatusHistoryIncidentItem from '@/components/status-history/status-history-incident-item'
import StatusHistoryMaintenanceItem from '@/components/status-history/status-history-maintenance-item'
import { MESSAGE_TYPE } from '@/constants'

export default {
  name: 'StatusSection',
  inject: ['screen'],
  mixins: [uid],
  components: { DsLink, StatusCard, StatusGroupTransition, StatusHistoryIncidentItem, StatusHistoryMaintenanceItem },
  props: {
    title: { type: String, default: '' },
    link: { type: Object, default: null, validator: obj => ['content', 'url'].every(key => key in obj) },
    items: { type: Array, default: () => ([]) },
    type: { type: String, required: true, validator: str => ['maintenance', 'incident'].includes(str) },
    errorMessage: { type: String, default: 'No items to show' },
    isOpen: { type: Boolean, default: false },
    withVerticalSpacing: { type: Boolean, default: true }
  },
  computed: {
    cardColor () {
      return 'light' // this.isIncident ? 'light' : 'grey'
    },
    sectionType () {
      return this.isIncident ? 'StatusHistoryIncidentItem' : 'StatusHistoryMaintenanceItem';
    },
    isIncident () {
      return this.type === MESSAGE_TYPE.INCIDENT
    }
  }
}
</script>
